import dynamic from "next/dynamic";

import React from "react";

import addYears from "date-fns/addYears";
import { Entity } from "models/entity";

import DividendPaymentsTable from "./DividendPaymentsTable";

const DividendPaymentsChart = dynamic(() => import("./DividendPaymentsChart"), {
  ssr: false,
});

const DividendYieldsChart = dynamic(() => import("./DividendYieldsChart"), {
  ssr: false,
});

const DEFAULT_START_DATE = addYears(new Date(), -5);
const DEFAULT_END_DATE = new Date();

interface EntityPageDividendProps {
  entity: Entity;
  startDate?: Date;
  endDate?: Date;
}

const EntityPageDividend = ({
  entity,
  startDate = DEFAULT_START_DATE,
  endDate = DEFAULT_END_DATE,
}: EntityPageDividendProps) => {
  return (
    <div id="dividend" className="">
      <DividendYieldsChart
        entity={entity}
        startDate={startDate}
        endDate={endDate}
      />
      <DividendPaymentsChart
        entity={entity}
        startDate={startDate}
        endDate={endDate}
      />
      <DividendPaymentsTable
        entity={entity}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
};

export default EntityPageDividend;
